import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteContextService } from '@context/old_index';

@Injectable()
export class DashboardService {

  constructor(
    private readonly routeContextService: RouteContextService
  ) { }

  canAddWidgets(route: ActivatedRoute): boolean {
    const ctx = this.routeContextService.getRouteContextFromRouteData(route);
    if (ctx && ctx.kind === 'DashboardRouteContext') {
      return ctx.allowWidgetAdd;
    }
    return false;
  }

}
